import { render, staticRenderFns } from "./ShProductsCard.vue?vue&type=template&id=be4f7914&scoped=true&"
import script from "./ShProductsCard.vue?vue&type=script&lang=js&"
export * from "./ShProductsCard.vue?vue&type=script&lang=js&"
import style0 from "./ShProductsCard.vue?vue&type=style&index=0&id=be4f7914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4f7914",
  null
  
)

export default component.exports